const baseURL = "https://hzerobak.linkcrm.cn:8082/"
const storageKey = "HzeroAuthorization"

export default (Axios) => {

	/**
	 * 获取token，后续改成直接从localStorage中获取
	 * @author  韦胜健
	 * @date    2020/2/20 16:40
	 */
	const getHzeroAuthorizontal = () => {
		const df = LinkUtils.defer()
		Vue.prototype.$dialog.show({
			title: '请输入token',
			editType: 'textarea',
			editValue: '',
			onConfirm: (val) => df.resolve(val),
			onCancel: () => df.reject(),
			confirmButton: true,
			// noClose: true,
		})
		return df.promise

		// return linkToken.getLocalToken()
	}

	/**
	 * 拦截器
	 * @author  韦胜健
	 * @date    2020/2/20 16:45
	 */
	const interceptor = {
		request: {
			before: async (config) => {
				let Authorization, timer;
				let HzeroAuthorization = window.localStorage.getItem(storageKey)

				try {
					if (!HzeroAuthorization) {
						Authorization = await getHzeroAuthorizontal()
						timer = Date.now() + 1000 * 60 * 60				// 缓存一个小时
					} else {
						HzeroAuthorization = JSON.parse(HzeroAuthorization)
						if ((HzeroAuthorization.timer - 0) < Date.now()) {
							Authorization = await getHzeroAuthorizontal()
							timer = Date.now() + 1000 * 60 * 60
						} else {
							Authorization = HzeroAuthorization.Authorization
							timer = HzeroAuthorization.timer
						}
					}
				} catch (e) {
					console.log(e)
					throw new Error('无法获取token')
				}

				window.localStorage.setItem(storageKey, JSON.stringify({Authorization, timer}))
				config.headers.Authorization = Authorization

				return config
			},
			error: async (e) => {
				console.log({...(e || {})})
				console.error(e)
				if (!!e && !!e.response && e.response.status === 401) {
					window.localStorage.removeItem(storageKey)
				}
				throw e
			}
		},
		response: {
			after: (resp) => {
				return resp
			},
			error: (e) => {
				console.log({...(e || {})})
				console.error(e)
				if (!!e && !!e.response && e.response.status === 401) {
					window.localStorage.removeItem(storageKey)
				}
				throw e
			},
		},
	}

	const TargetAxios = Axios || window.Axios

	if (!!TargetAxios) {
		const hzeroAxios = Axios.create({
			baseURL: baseURL,
		})

		hzeroAxios.interceptors.request.use(interceptor.request.before, interceptor.request.error)
		hzeroAxios.interceptors.response.use(interceptor.response.after, interceptor.response.error)

		return hzeroAxios
	} else {
		return null
	}
}